"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const MyCompsIcon = createIcon({
  displayName: "MyCompsIcon",
  viewBox: "0 0 45 34.46",
  path: (
    <>
      <path
        d="M44.74,7.87c-.19-.3-.43-.56-.75-.75l-5.27-3.03c-.65-.37-1.4-.37-2.04,0l-5.27,3.03c-.32.19-.58.45-.75.75-.17.3-.28.65-.28,1.01v6c0,.37.11.71.28,1.01.17.3.43.56.75.75l5.27,3.03c.32.17.67.26,1.01.26.37,0,.71-.09,1.03-.26l5.27-3.03c.32-.19.56-.45.75-.75.17-.3.26-.65.26-1.01v-6c0-.37-.09-.71-.26-1.01ZM32.95,14.54v-3.91l3.44,2v3.91l-3.44-2ZM37.69,10.39l-3.38-1.96,3.38-1.96,3.4,1.96-3.4,1.96ZM42.42,14.54l-3.44,2v-3.91l3.44-2v3.91Z"
        fill="currentColor"
      />
      <path
        d="M17.21,17.25c-2.37,0-4.39-.84-6.09-2.54-1.68-1.68-2.54-3.72-2.54-6.09s.84-4.39,2.54-6.09c1.68-1.68,3.72-2.54,6.09-2.54s4.39.84,6.09,2.54c1.7,1.7,2.54,3.72,2.54,6.09s-.84,4.39-2.54,6.09c-1.68,1.68-3.72,2.54-6.09,2.54ZM0,34.46v-6.02c0-1.23.32-2.34.95-3.36.62-1.03,1.46-1.81,2.5-2.34,2.22-1.12,4.47-1.94,6.78-2.5,2.3-.56,4.62-.84,6.99-.84s4.69.28,6.99.84c2.3.56,4.56,1.4,6.78,2.5,1.03.54,1.87,1.31,2.5,2.34.62,1.03.95,2.15.95,3.36v6.02H0ZM4.3,30.16h25.81v-1.72c0-.39-.11-.75-.3-1.08-.19-.32-.45-.58-.77-.75-1.94-.97-3.89-1.7-5.87-2.17s-3.96-.73-5.98-.73-4,.24-5.98.73c-1.98.49-3.94,1.2-5.87,2.17-.32.17-.58.43-.77.75-.19.32-.3.69-.3,1.08v1.72h.04ZM17.21,12.95c1.18,0,2.19-.43,3.03-1.27.84-.84,1.27-1.85,1.27-3.03s-.43-2.19-1.27-3.03c-.84-.84-1.85-1.27-3.03-1.27s-2.19.43-3.03,1.27c-.84.84-1.27,1.85-1.27,3.03s.43,2.19,1.27,3.03c.84.84,1.85,1.27,3.03,1.27Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default MyCompsIcon;
